/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Directive, HostListener} from '@angular/core';
import {ConfirmDialog} from 'primeng/confirmdialog';

/**
 * PrimeNG ConfirmDialog focuses No first, so Enter cancels. This makes Enter trigger Yes
 * while that dialog is visible.
 */
@Directive({
    selector: 'p-confirmDialog[esciConfirmEnterAccept], p-confirmdialog[esciConfirmEnterAccept]',
    standalone: true
})
export class ConfirmEnterAcceptDirective {
    constructor(private readonly confirmDialog: ConfirmDialog) {
    }

    @HostListener('document:keydown.enter', ['$event'])
    onEnter(event: KeyboardEvent): void {
        if (!this.confirmDialog.visible) {
            return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        this.confirmDialog.onAccept();
    }
}
